import { render } from "./TooltipWithShowMoreOption.vue?vue&type=template&id=12a32be9&scoped=true"
import script from "./TooltipWithShowMoreOption.vue?vue&type=script&lang=js"
export * from "./TooltipWithShowMoreOption.vue?vue&type=script&lang=js"

import "./TooltipWithShowMoreOption.vue?vue&type=style&index=0&id=12a32be9&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a32be9"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QIcon});
